import { render, staticRenderFns } from "./SelectVcDemo.vue?vue&type=template&id=20af76e8&scoped=true&"
import script from "./SelectVcDemo.vue?vue&type=script&lang=js&"
export * from "./SelectVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./SelectVcDemo.vue?vue&type=style&index=0&id=20af76e8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20af76e8",
  null
  
)

export default component.exports